<template>
  <div>
    <page-toolbar>
      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
      <vonap-toolbar-label label="Show matched">
        <v-switch
          @change="onShowMatchedChanged"
          :style="'display:inline-block;margin:-6px 0;width:61px;top: 4px;position:relative'"
          v-model="showMatched"
        >
        </v-switch>
      </vonap-toolbar-label>
    </page-toolbar>
    <kendo-grid
      ref="matchGrid"
      :autoBind="false"
      :height="'calc(100vh - 332px)'"
      :dataSource="dataSource"
      :data-bound="dataBound"
      :editable="'inline'"
      :filterable="true"
      :sortable="true"
      :pageable="true"
      :pageable-always-visible="true"
      :columns="columns"
    >
    </kendo-grid>
  </div>
</template>
<script>
import $ from '@/helpers/jquery-bridge'
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
import {checkboxColumn} from '@/helpers/kendo-editors'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
export default {
  name: 'ContactListMatch',
  model: {prop: 'refresh', event: 'input'},
  props: {
    refresh: {type: Boolean, required: true},
    asOfDate: {type: String, required: false},
  },
  data() {
    return {
      showMatched: false,
      grid() {
        return this.$refs.matchGrid.kendoWidget()
      },
      dataBound: function(e) {
        e.sender.element.find('tbody tr').each(function(i, el) {
          const dataItem = e.sender.dataItem(el)
          if (dataItem.mismatchId > 0 && dataItem.match === false) {
            let cells = $(el).find('td')
            switch (dataItem.mismatchId) {
              case 1: //mail mismatch
                cells[0].style.backgroundColor = 'yellow'
                cells[5].style.backgroundColor = 'yellow'
                break
              case 2: //code mismatch
              case 5: //mapping code mismatch
                cells[1].style.backgroundColor = 'yellow'
                cells[6].style.backgroundColor = 'yellow'
                break
              case 3: //first lName mismatch
                cells[2].style.backgroundColor = 'yellow'
                cells[7].style.backgroundColor = 'yellow'
                break
              case 4: //last Name mismatch
                cells[3].style.backgroundColor = 'yellow'
                cells[8].style.backgroundColor = 'yellow'
                break
            }
          }
        })
      },
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 10,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/monthlyReportSendingList/getMatchDataSource',
            data: () => ({
              asOfDate: this.asOfDate,
              showMatched: this.showMatched,
            }),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/monthlyReportSendingList/matchContact',
            data: () => ({
              reportDate: this.asOfDate,
            }),
            dataType: 'json',
            complete: () => {
              this.grid().dataSource.read()
              this.grid().dataSource.page(1)
            },
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'monthlyReportEmailId',
            fields: {
              monthlyReportEmailId: {type: 'number', defaultValue: 1},
              starEmail: {type: 'string', editable: false},
              starClientName: {type: 'string', editable: false},
              starFirstName: {type: 'string', editable: false},
              starLastName: {type: 'string', editable: false},
              contactListEmail: {type: 'string', editable: false},
              contactListClientName: {type: 'string', editable: false},
              contactListFirstName: {type: 'string', editable: false},
              contactListLastName: {type: 'string', editable: false},
              match: {type: 'boolean', defaultValue: true, editable: true},
              mismatchId: {type: 'number', editable: false},
            },
          },
        },
      }),
      columns: [
        {
          title: 'Contact List',
          headerAttributes: {
            style: 'font-size:16px;background-color:#1E3575;border-bottom:1px solid #a1a1a1',
          },
          columns: [
            {
              field: 'contactListEmail',
              title: 'Email',
              width: 132,
              attributes: {style: 'text-align:left, colspan:2 '},
              headerAttributes: {style: 'background-color: #1E3575;'},
            },
            {
              field: 'contactListClientName',
              title: 'Client',
              width: 100,
              attributes: {style: 'text-align:left'},
              headerAttributes: {style: 'background-color: #1E3575;'},
            },
            {
              field: 'contactListFirstName',
              title: 'First Name',
              width: 50,
              attributes: {style: 'text-align:left, colspan:2 '},
              headerAttributes: {style: 'background-color: #1E3575;'},
            },
            {
              field: 'contactListLastName',
              title: 'Last Name',
              width: 100,
              attributes: {style: 'text-align:left'},
              headerAttributes: {style: 'background-color: #1E3575;'},
            },
          ],
        },
        checkboxColumn(
          'match',
          {
            title: 'Match',
            width: 55,
            hideByDefault: true,
            headerAttributes: {style: 'font-size:16px;background-color:#1E353D;text-align:end'},
          },
          false,
          null,
          function(dataItem) {
            return dataItem.match
          },
        ),
        {
          title: 'Bon Coup List',
          headerAttributes: {style: 'font-size:16px;border-bottom:1px solid #a1a1a1'},
          columns: [
            {
              field: 'starEmail',
              title: 'Email',
              width: 132,
              attributes: {style: 'text-align:left, colspan:2 '},
            },
            {
              field: 'starClientName',
              title: 'Client',
              width: 100,
              attributes: {style: 'text-align:left'},
            },
            {
              field: 'starFirstName',
              title: 'First Name',
              width: 50,
              attributes: {style: 'text-align:left, colspan:2 '},
            },
            {
              field: 'starLastName',
              title: 'Last Name',
              width: 100,
              attributes: {style: 'text-align:left'},
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  watch: {
    refresh: function() {
      this.gridRefresh()
    },
  },
  methods: {
    onShowMatchedChanged() {
      this.gridRefresh()
    },
    exportToExcel() {
      window.location.href = `/api/report/monthlyReportSendingList/exportMatchToExcel?asOfDate=${
        this.asOfDate
      }&showMatched=${this.showMatched}&t=${this.tokenString}`
    },
    gridRefresh() {
      const grid = this.$refs.matchGrid.kendoWidget()
      grid.dataSource.read()
      grid.dataSource.page(1)
      grid.refresh()
    },
  },
  components: {
    PageToolbar,
    VonapToolbarLabel,
  },
}
</script>
